import {startOfWeek, addDays, subWeeks, isWithinInterval} from 'date-fns';

export const calculateSupervisionCompliance = (sessions: any[]) => {
  const now = new Date();
  const weeks: {
    week: string;
    start: Date;
    end: Date;
    total: number;
    supervision: number;
  }[] = [];

  // Build 12 trailing weekly intervals
  for (let i = 11; i >= 0; i--) {
    const start = startOfWeek(subWeeks(now, i), {weekStartsOn: 0}); // Sunday
    const end = addDays(start, 7); // Next Sunday
    weeks.push({
      week: start.toISOString().split('T')[0],
      start,
      end,
      total: 0,
      supervision: 0,
    });
  }

  for (const session of sessions) {
    const {cpt, editedStartTimestamp, editedEndTimestamp} = session;
    if (!cpt || !cpt.length || cpt.includes('00000')) {
      continue;
    }

    const start = new Date(editedStartTimestamp);
    const end = new Date(editedEndTimestamp);
    const durationHours = (end.getTime() - start.getTime()) / 3600000;

    if (durationHours <= 0 || durationHours < 0.0833) {
      continue;
    }

    for (const week of weeks) {
      if (isWithinInterval(start, {start: week.start, end: week.end})) {
        week.total += durationHours;
        if (cpt.includes('97155')) {
          week.supervision += durationHours;
        }
        break;
      }
    }
  }

  return weeks.map(({week, total, supervision}) => {
    const percentage = total > 0 ? (supervision / total) * 100 : 0;
    return {
      week,
      percentage: Math.abs(percentage) < 0.01 ? 0 : percentage,
      total: Math.abs(total) < 0.01 ? 0 : total,
      supervision: Math.abs(supervision) < 0.01 ? 0 : supervision,
    };
  });
};
